export const API_PROGRAM_EVENTS_INDEX = 'API_PROGRAM_EVENTS_INDEX'

export const fetch = (month: string) => ({
  type: API_PROGRAM_EVENTS_INDEX,
  month,
})
